import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function PricingCTA() {
  return <section id="comprar" className="w-full max-w-2xl mx-auto px-4 py-16 pb-32" data-id="element-205">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="bg-[#111] border border-white/10 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-206">
        {/* Background Glow */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-gradient-to-b from-[#FE2C55]/5 to-transparent -z-10" data-id="element-207" />

        <div className="mb-8" data-id="element-208">
          <span className="text-gray-500 text-lg line-through block mb-2" data-id="element-209">
            $97
          </span>
          <span className="text-6xl md:text-8xl font-black text-white tracking-tighter" data-id="element-210">
            $27
          </span>
        </div>

        <p className="text-lg text-gray-400 mb-10 max-w-md mx-auto" data-id="element-211">
          Lo que te cuesta una salida rápida… y a veces ni te deja nada. Esto sí
          te deja un sistema.
        </p>

        <a href="https://modoconstante.com/cart/47444542292155:1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full px-8 py-5 bg-[#FE2C55] hover:bg-[#D91A40] text-white text-xl font-bold rounded-full shadow-[0_0_40px_rgba(254,44,85,0.3)] transition-all transform hover:scale-105 mb-6" data-id="element-212">
          Consigue tu Starter Sprint ahora — $27
          <ArrowRight className="ml-2 w-6 h-6" data-id="element-213" />
        </a>

        <p className="text-gray-300 font-medium mb-8" data-id="element-214">
          y hoy mismo publica tu Día 1.
        </p>

        <p className="text-sm text-gray-500 italic border-t border-white/10 pt-8" data-id="element-215">
          "Si estás cansado de empezar fuerte y desaparecer en silencio: esto es
          lo tuyo."
        </p>
      </motion.div>
    </section>;
}